export default [{"url":"https://inctest-0.api.invexone.com","name":"inctest","port":"6512","isStore":true,"isHQ":true}]